<template>
  <div class="main-box exam-list-box" v-loader.opacity="loading">
    <div class="exam-list-header">
      <div class="">
        <div class="title-box clear">
          <h2 class="title">{{ $t("exam.examsList") }}</h2>

          <button class="btn btn-outline-secondary" type="button" name="button" data-test="btnAddNewExam"
            @click="openOffCanvasNewExam">
            <IconPlus />
            <span>{{ $t('exam.createExam') }}</span>
          </button>


          <div class="dropdown">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              <IconDot class="icon-dot" />
            </button>
            <ul class="dropdown-menu">
              <li>
                <a class="dropdown-item" data-test="btnAddDownloadExamDropdown" @click="openOffcanvasExamDownload">{{ $t('exam.exportExam') }}</a>
              </li>
              <li>
                <a class="dropdown-item" data-test="btnAddExportExamDropd'own" @click="openOffcanvasExamExport">{{ $t('reportExam.exportExamByMonth') }}</a>
              </li>
              <li>
                <a class="dropdown-item" data-test="btnAddNewExamDropdown" @click="openOffCanvasNewExam">{{ $t('exam.createExam') }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="">
        <div v-if="tableExam" class="align-items-center page-row">
          <p class="pagination-total" v-if='responseType !== "filtered"'>{{ `${tableExam.total} ${$t("pagination.exams")}` }}</p>
          <BasePagination :total-pages="totalPages" :total="tableExam.total"
                          :per-page="perPage" :current-page="currentPage" :type="responseType" @pagechanged="onPageChange"/>
        </div>

        <div class="table-type-box">
          <div class="btn-group" role="group" aria-label="Action button group">
            <div class="image-range-box" v-if="tableType == 'grid' && !isSmallScreen">
              <button class="no-btn" type="button" name="button" @click="scaleImages--; setScaleImageLocalStorage(scaleImages)" :disabled="scaleImages == 1">
                <IconGrid />
              </button>
              <input type="range"
                     class="form-range d-inline-block"
                     id="imageRange"
                     v-model.number="scaleImages"
                     min="1" max="4" step="1"
                     @keydown.left.stop="void 0"
                     @keydown.right.stop="void 0"
                     @change="setScaleImageLocalStorage(scaleImages)">
              <button class="no-btn" type="button" name="button" @click="scaleImages++; setScaleImageLocalStorage(scaleImages)" :disabled="scaleImages == 4">
                <IconGridBig />
              </button>
            </div>

            <div v-else-if="tableType != 'grid' || isSmallScreen">
              <input type="radio" class="btn-check" name="btn-radio" id="btnGrid" autocomplete="off"
                     :checked="tableType == 'grid'" @click="setTableLocalStorage('grid')"
                     @keydown.left.stop.prevent="void 0" @keydown.right.stop.prevent="void 0">
              <label class="btn btn-outline-secondary" for="btnGrid">
                <IconGrid />
                <span>{{ $t('exam.grid') }}</span>
              </label>
            </div>

            <input type="radio" class="btn-check" name="btn-radio" id="btnList" autocomplete="off"
                   :checked="tableType == 'list'" @click="setTableLocalStorage('list')"
                   @keydown.left.stop.prevent="void 0" @keydown.right.stop.prevent="void 0">
            <label class="btn btn-outline-secondary" for="btnList">
              <IconList />
              <span>{{ $t('exam.list') }}</span>
            </label>
          </div>
        </div>


        <teleport to="body" v-if="showTips">
          <div class="tips" id="tips">
            <button class="no-btn" type="button" name="button" @click="closeAndIncrementTipsCount">
              <IconClose />
            </button>
            <p>
              {{ $t('welcomeTips.examModes') }}
            </p>
          </div>
        </teleport>
      </div>
    </div>

    <div class="no-results-box" v-if="alert.message">
      <BaseNoResults :title="alert.title" :text="alert.message"/>
    </div>

    <div ref="tableBox" id="tableBox">
      <ExamTableList :table_exam="tableExam" :thumb_path="thumbDataPath" v-if="tableExam && tableType == 'list'"
        @do-assign="openAssignOffcanvas" @item-opened="examSelected" @do-reload="performDataFetch(examFilterStore.filter)"/>

      <ExamGridList :table_exam="tableExam" :thumb_path="thumbDataPath" :data_path="dataPath" :scale="scaleImages"
        v-if="tableExam && tableType == 'grid'" @do-assign="openAssignOffcanvas" @item-opened="examSelected" @do-reload="performDataFetch(examFilterStore.filter)"/>
    </div>

    <teleport to="body">
      <ExamDownloadOffcanvas :offcanvas_id="'ExamDownloadOffcanvas'" ref="examDownloadOffcanvas"/>
      <ExamExportByMonthOffcanvas :offcanvas_id="'ExamExportByMonthOffcanvas'" ref="examExportByMonthOffcanvas"/>
      <ExamNewOffcanvas ref="examNewOffcanvas" @close="handleOffcanvasClose()"/>
      <ExamAssignPatientOffcanvas :offcanvas_id="'ExamAssignPatientOffcanvas'" ref="examAssignPatientOffcanvas" @patient-assigned="closeAssignOffCanvas"/>
    </teleport>
  </div>
</template>

<style lang="scss" src="./exam-list.scss" scoped></style>
<script src="./exam-list.js"></script>
